<section *ngIf="site && latestSiteData" class="site-detail-section">
  <ng-container *ngIf="isOuter && isOffHours">
    <div class="site-detail-off-hours">
      <div>ただいまの時間は利用できません</div>
      <div>利用時間は5:00〜19:00です</div>
    </div>
  </ng-container>
  <ng-container *ngIf="!isOuter || !isOffHours">
    <div class="site-detail-sitename-area">
      <mat-card class="site-detail-sitename-card">
        <div>
          <span class="site-detail-sitename-title">現場名:</span>
          <span class="site-detail-sitename-body">
            {{ site!.name }} （山留変位計測）
          </span>

          <span class="ml-8" (click)="onUsageGuideClick()">
            <button mat-raised-button class="text-2xl font-bold">凡例</button>
          </span>
        </div>
      </mat-card>
    </div>

    <!-- センサーアラートエリア -->
    <div class="w-full mb-8">
      <app-site-detail-tilt-alert
        [site]="site"
        [latestSiteData]="latestSiteData"
      ></app-site-detail-tilt-alert>
    </div>

    <div class="mb-8">
      <app-site-detail-tilt-drawing [site]="site">
      </app-site-detail-tilt-drawing>
    </div>

    <div class="mb-8">
      <app-site-detail-tilt-sensors [latestSiteData]="latestSiteData">
      </app-site-detail-tilt-sensors>
    </div>

    <div class="mb-8 w-full" *ngIf="!isOuter">
      <app-site-detail-tilt-charts [latestSiteData]="latestSiteData">
      </app-site-detail-tilt-charts>
    </div>
  </ng-container>
</section>
